import React, { useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import GeneralPolicies from "components/hotel_additional_info_section/policies/general_policies";
import styles from "./room_details_modal.module.css";

import Separator from "components/layout/separator/separator";
import Carousel from "react-bootstrap/Carousel";
import { useMedia } from "react-media";
import MEDIA_QUERIES from "constants/media_queries";
import { CloseCircleOutlined } from "@ant-design/icons";

const FACILITY_DIVIDER = " Â· ";

export default function RoomDetailsModal({ room, show, onHide, property }) {
  const { t } = useTranslation();
  const { photos, description, title, facilities } = room;

  const hotelPolicy = property?.hotelPolicy;
  const hotelInfo = hotelPolicy || {};
  const matchedQueries = useMedia({ queries: MEDIA_QUERIES });

  const isMobile = matchedQueries.xs || matchedQueries.sm || matchedQueries.md;

  const allPhotos = photos?.length > 0 ? photos : [];
  const { internetAccessType, parkingType, smokingPolicy, petsPolicy } = hotelInfo;
  const isInternetAvailable = internetAccessType !== "none" && internetAccessType;
  const isParkingAvailable = parkingType !== "none" && parkingType;
  const isPetAllowed = petsPolicy !== "not_allowed" && petsPolicy;
  const roomFacilities = useMemo(
    () =>
      facilities
        .reduce((acc, facilityGroup) => [...acc, ...facilityGroup.facilities], [])
        .map((facility) => {
          return t(`facilities:${facility.toLowerCase()}`);
        })
        .join(FACILITY_DIVIDER),
    [facilities, t],
  );

  const isFacilitiesPresent = Boolean(roomFacilities.length);

  return (
    <Modal dialogClassName={styles.modal} show={show} onHide={onHide}>
      <Modal.Body className={styles.modalBody}>
        <Modal.Header className={styles.modalHeader}>
          <h5>{title}</h5>
          <CloseCircleOutlined onClick={onHide} style={{ fontSize: 20, cursor: "pointer" }} />
        </Modal.Header>
        <Separator />
        <div>
          <div className={styles.modalMain}>
            <div className={styles.photosDesktop}>
              <div>
                <Carousel
                  // activeIndex={activeIndex}
                  // controls={false}
                  pause="hover"
                  wrap={true}
                  interval={1000}
                  defaultActiveIndex={0}
                  fade
                >
                  {allPhotos?.map((photo) => (
                    <Carousel.Item key={photo?.url}>
                      <img className={styles.mainImage} src={photo?.url} alt={"carosel-item"} />
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
              {isMobile && (
                <div className={styles.modalContent}>
                  <div>
                    <h4 className={styles.title}>{title}</h4>
                    <h5 className={styles.desc}>{description}</h5>
                  </div>
                  <div>
                    <h4 className={styles.title}>Room Facilities</h4>
                    {isFacilitiesPresent && (
                      <>
                        <div>
                          {facilities.map((facility) =>
                            facility.facilities.map((item, index) => (
                              <ul key={index}>
                                <li lable={t("rates_table:room_facilities")}>{item}</li>
                              </ul>
                            )),
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
              <div className={styles.details}>
                <div className="mt-4">
                  <div>
                    {isInternetAvailable ? (
                      <img src=".././wifi.png" alt="wifi" className={styles.iconImage} />
                    ) : (
                      <>
                        <img src=".././no-signal.png" alt="no wifi" className={styles.iconImage} />
                      </>
                    )}
                    {isParkingAvailable ? (
                      <img src=".././parking.png" alt="parking" className={styles.iconImage} />
                    ) : (
                      <>
                        <img
                          src=".././no-parking.png"
                          alt="no parking"
                          className={styles.iconImage}
                        />
                      </>
                    )}
                    {smokingPolicy === "no_smoking" ? (
                      <>
                        {" "}
                        <img
                          src=".././no-smoking.png"
                          alt="smoking"
                          className={styles.iconImage}
                        />{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <img
                          src=".././smoking.png"
                          alt="no-smoking"
                          className={styles.iconImage}
                        />{" "}
                      </>
                    )}
                    {isPetAllowed ? (
                      <>
                        {" "}
                        <img
                          src=".././pet-care.png"
                          alt="pets Allowed"
                          className={styles.iconImage}
                        />
                      </>
                    ) : (
                      <>
                        {" "}
                        <img
                          src=".././no-pet.png"
                          alt="no pet allowed"
                          className={styles.iconImage}
                        />
                      </>
                    )}
                  </div>
                  <div className="my-4">
                    {hotelPolicy ? (
                      <>
                        {" "}
                        <h6 className={styles.heading}>Check In Check Out:</h6>
                        <GeneralPolicies hotelPolicy={hotelPolicy} />{" "}
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <Separator />
                <div className="mt-3">
                  <h6 className={styles.heading}>Contact Details</h6>
                  <div>
                    <span className={styles.hotel}>{property?.title}</span>
                    <p className={styles.address}>{property?.address}</p>
                    {property?.phone ? (
                      <p>
                        <span className={styles.heading}>
                          {" "}
                          <i className={"fa-solid fa-phone"}></i>
                        </span>{" "}
                        {property.phone}
                      </p>
                    ) : (
                      <></>
                    )}
                    {property?.email ? (
                      <p>
                        <span className={styles.heading}>
                          <i className={"fa-solid fa-mail"}></i>
                        </span>{" "}
                        {property.email}
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <Separator />
              </div>
            </div>
            {!isMobile && (
              <div className={styles.modalContent}>
                <div>
                  <h4 className={styles.title}>{title}</h4>
                  <h5 className={styles.desc}>{description}</h5>
                </div>
                <div>
                  <h4 className={styles.title}>Room Facilities</h4>
                  {isFacilitiesPresent && (
                    <>
                      <div>
                        {facilities.map((facility) =>
                          facility.facilities.map((item, index) => (
                            <ul key={index}>
                              <li lable={t("rates_table:room_facilities")}>{item}</li>
                            </ul>
                          )),
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
